// Exchange rates — update these values manually as needed
// Last updated: April 2026

const RATES = {
  IQD_USD: 0.000763,  // 1 IQD = 0.000763 USD  (≈ 1310 IQD per 1 USD)
  USD_IQD: 1310,      // 1 USD = 1310 IQD
  IQD_EUR: 0.000700,  // 1 IQD = 0.000700 EUR  (≈ 1428 IQD per 1 EUR)
  EUR_IQD: 1428,      // 1 EUR = 1428 IQD
  USD_EUR: 0.917,     // 1 USD = 0.917 EUR
  EUR_USD: 1.090,     // 1 EUR = 1.090 USD
};

export default RATES;
